import { getApiToken, getUserByUsessionid, getUserResByUsessionid, getResToken } from '@/api/user.js'
import { getBooksList } from '@/api/books.js'
import * as authcookie from '@/api/authcookie.js'
const MINI_P_STRING = 'MINI_'
const user = {
  state: {
    userid: null,
    username: null,
    avatar: '',
    usessionid: authcookie.getUsessionid(), // 用于获得用户信息
    restoken: '', // 用于获取资源的权限校验接口，此参数登录后会配置好，直接饮用即可，超时会跳转登录页面
    token: authcookie.getToken(), // 此参数用于用户相关接口的api权限
    history: null,
    openid: '',
    nickname: '',
    today: '',
    hasbuy: {},
    hasbuy_mini: {},
    ip: '',
    hasread: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      authcookie.setToken(token)
      state.token = token
    },
    SET_RES_TOKEN: (state, token) => {
      state.restoken = token
    },
    SET_USER_TOKEN: (state, data) => {
      authcookie.setUsessionid(data.usessionid)
      state.userid = data.userid
      state.username = data.username
      state.avatar = data.avatar
      state.usessionid = data.usessionid
      state.openid = data.openid
      state.nickname = data.nickname
    },
    REMOVE_USER_TOKEN: (state) => {
      state.userid = null
      state.username = null
      state.avatar = ''
      state.usessionid = ''
      state.restoken = ''
      authcookie.removeUsessionid()
    },
    SET_USER_RES: (state, data) => {
      if (data instanceof Array) {
        console.log(this.getters)
        const books = window.config.booklist
        const his = []
        const has = {}
        const has_mini = {}
        if (data.length > 0) {
          const v = data[0]
          state.ip = v.ip
          state.today = v.date
          data.forEach(function(v, k) {
            if (k >= 0) {
              if (v.res && v.deadline) {
                let bod = v.res
                if (bod.indexOf(MINI_P_STRING) === 0) {
                  bod = bod.replace(MINI_P_STRING, '')
                }
                if (books.hasOwnProperty(bod)) {
                  v.activateTime = v.activateTime.split(' ')[0]
                  v.showName = books[bod].showName
                  his.push(v)
                }
              }
              if (v.res && v.deadline && v.deadline >= state.today) {
                const bookres = v.res.replace(MINI_P_STRING, '')
                if (books[bookres]) {
                  const bvo = books[bookres]
                  const ta = bvo.books.split(',')
                  ta.forEach(function(bid, j) {
                    if (books[bid]) {
                      has_mini[bid] = true
                      if (v.res.indexOf(MINI_P_STRING) === -1) {
                        has[bid] = true
                      }
                    }
                  })
                }
              }
            }
          })
        }
        state.history = his.reverse()
        state.hasbuy = has
        state.hasbuy_mini = has_mini
      }
    },
    REMOVE_USER_RES: (state) => {
      state.history = null
      state.deadline = ''
    }
  },

  actions: {
    updateBookList({ commit, state }) {
      return new Promise((resolve, reject) => {
        state.hasread = authcookie.getReadBook()
        if (state.booklist) {
          resolve(state.booklist)
          return
        }
        getBooksList().then(response => {
          if (response.hasOwnProperty('3lall')) {
            const config = {}
            config.booklist = response
            config.c3l = response['3lall'].books.split(',')
            config.c1l = response['1lall'].books.split(',')
            config.cjh = response['jall'].books.split(',')
            config.csh = response['sall'].books.split(',')
            window.config = config
            window.MINI_P_STRING = MINI_P_STRING
            resolve(state.booklist)
          } else {
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    addReadBook({ commit, state }, bookid) {
      state.hasread = authcookie.addReadBook(bookid)
    },
    getApiToken({ commit }) {
      authcookie.removeToken()
      commit('SET_TOKEN', '')
      return new Promise((resolve, reject) => {
        getApiToken(Date.now()).then(response => {
          commit('SET_TOKEN', response.token)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    // get user info 此处写法应当可以基于es6优化可读性，暂存
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserByUsessionid(state.usessionid).then(response => {
          const data = response.userinfo
          commit('SET_USER_TOKEN', data)
          if (!window.config || !window.config.booklist) {
            resolve()
            return
          }
          // 获得restoken
          getResToken(state.usessionid).then(response => {
            commit('SET_RES_TOKEN', response.token)
            getUserResByUsessionid(state.userid).then(response => {
              commit('SET_USER_RES', response)
              resolve()
            }).catch(error => {
              reject(error)
            })
          }).catch(err => {
            reject(err)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    // get user res
    getUserRes({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserResByUsessionid(state.userid).then(response => {
          commit('SET_USER_RES', response)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // remove user token
    resetUserToken({ commit }) {
      return new Promise(resolve => {
        commit('REMOVE_USER_TOKEN')
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js